export type FocusDirection = 'next' | 'prev';

const FOCUSABLE_SELECTOR =
	'a[href], button, input, select, textarea, audio[controls], video[controls], [contenteditable]:not([contenteditable="false"]), [tabindex]';

const isTabbable = (element: HTMLElement): boolean =>
	element.tabIndex >= 0 && !element.matches(':disabled') && element.getClientRects().length > 0;

/** Moves focus to the adjacent tabbable inside `container`, wrapping; from outside it enters at the first or last. */
export const focusSibling = (container: HTMLElement, direction: FocusDirection): void => {
	const items = Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
		isTabbable
	);
	if (items.length === 0) return;
	const index = items.findIndex((item) => item === document.activeElement);
	let target = direction === 'next' ? 0 : items.length - 1;
	if (index !== -1) {
		const step = direction === 'next' ? 1 : -1;
		target = (index + step + items.length) % items.length;
	}
	items[target]!.focus();
};
